export default [
  {
    component: () => import('@/modules/spell-checker/components/pages/Entry.vue'),
    name: 'spell-checker',
    path: '/spell-checker',
    children: [
      {
        component: () => import('@/modules/spell-checker/components/pages/Index.vue'),
        name: 'index',
        path: '',
      },
      {
        component: () => import('@/modules/spell-checker/components/pages/Safe.vue'),
        name: 'safe',
        path: 'safe',
      },
    ],
    meta: {
      metaTags: [
        {
          content: 'Spot potential spelling errors in your Etsy listings\' tags with eRank’s Spell Checker Tool.',
          name: 'description',
        },
        {
          page_slug: 'spell-checker',
        },
      ],
      requiresAuth: true,
      title: 'eRank — Spell Checker',
    },
    beforeEnter: () => {
      return { name: 'dashboard' };
    },
  },
];
